const OSS = {};
// eslint-disable-next-line
OSS.install = function (Vue) {
  // 4. 添加实例方法
  // eslint-disable-next-line
  Vue.prototype.$addOssUrl = (string) => `${process.env.VUE_APP_OSS_PREFIX}${string}`;
};
export default OSS;
